























































import Vue from 'vue'
import { StripeCustomerCard } from '@/types/StripeCustomer.interface'
import { mapGetters } from 'vuex'
import subscriptionMixin from '@/mixins/subscription-mixin.js'
import { randomKey } from '@/utility/helpers'
export default Vue.extend({
    mixins: [subscriptionMixin],
    data() {
        return {
            cardImages: {
                'American Express': '/media/images/amex.svg',
                'Diners Club': '/media/images/diners.svg',
                Discover: '/media/images/discover.svg',
                JCB: '/media/images/jcb.svg',
                MasterCard: '/media/images/mastercard.svg',
                UnionPay: '/media/images/union-pay.svg',
                Visa: '/media/images/visa.svg'
            },
            sourceKey: randomKey()
        }
    },
    async mounted() {
        if (!this.stripeCustomer && this.authIsAdmin) {
            await this.$store.dispatch('stripeCustomerFind', true)
        }
    },
    computed: {
        ...mapGetters(['authIsAdmin', 'stripeCustomer', 'stripeCustomerHasPayment']),
        sources() {
            //  Grab our stripe customer
            const customer = this.stripeCustomer

            //  If no customer, return empty array
            if (!customer) return []

            //  Else, return our sources
            return customer.sources.data
        }
    },
    methods: {
        async removeCard(
            dialog_result: boolean,
            card: StripeCustomerCard
        ): Promise<void> {
            //  If the dialog result if false, do nothing
            if (!dialog_result) return

            //  Else, remove user's the payment source
            const customer = await this.$store.dispatch('stripePaymentRemove', card.id)

            //  If the request failed, do nothing
            if (!customer) return

            //  Remove the card icon
            this.cardLogo = null

            //  Else, notify the user
            this.$store.commit('appNotificationBarSet', {
                message: 'You payment card has been removed',
                type: 'success'
            })
        },
        removeCardConfirm(card: StripeCustomerCard): void {
            //  Pop a confirm dialog
            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: 'Remove Payment Card?',
                text: 'Are you sure you want to remove this payment card?',
                icon: 'mdi-alert',
                color: 'red darken-2',
                callback: (result: boolean): void => this.removeCard(result, card)
            })
        }
    },
    watch: {
        stripeCustomer: {
            deep: true,
            handler(val) {
                //  Reset our key
                this.sourceKey = randomKey()
            }
        }
    }
})
